export const iosStoreUrl = 'https://apps.apple.com/app/spacetailor/id1529426388?ign-mpt=uo%3D2';
export const androidStoreUrl = 'https://play.google.com/store/apps/details?id=io.spacetailor.application';
